import { render, staticRenderFns } from "./Nsim.vue?vue&type=template&id=ab63e9c0&"
import script from "./Nsim.vue?vue&type=script&lang=js&"
export * from "./Nsim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports